import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helperSpinner from "../../../helpers/spinner";
import helperNumbers from "../../../helpers/numbers";
import helperTime from "../../../helpers/time";
import httpService from "../../../services/httpServices/httpServices";
import financeMessage from "../../../messages/finance";
import validator from "validator";
import Pagination from "../../partials/content/Pagination";

export default function AllWalletLogPosition() {
  const [message, setMessage] = useState();
  const [allWalletLogPosition, setAllWalletLogPosition] = useState([]);
  const [positionTagHtmlID, setPositionTagHtmlID] = useState();

  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);

  useEffect(() => {
    if (!positionTagHtmlID) {
      return;
    }
    getAllWalletLogPosition();
  }, [currentPage]);

  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const getPositionTagHtmlID = () => {
    const positionTagHtmlID = document
      .querySelector("#position-tag-html-id")
      .value.trim();

    if (!positionTagHtmlID) {
      setMessage({
        type_class: "alert alert-danger",
        text: financeMessage.POSITION_TAG_HTML_ID_INVALID,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    if (
      !positionTagHtmlID.includes(
        process.env.REACT_APP_HILITE_TAG_HTML_POSITION_ID
      )
    ) {
      setMessage({
        type_class: "alert alert-danger",
        text: financeMessage.POSITION_TAG_HTML_ID_INVALID,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    const positionID = positionTagHtmlID.replace(
      process.env.REACT_APP_HILITE_TAG_HTML_POSITION_ID,
      ""
    );

    if (!validator.isNumeric(positionID)) {
      setMessage({
        type_class: "alert alert-danger",
        text: financeMessage.POSITION_TAG_HTML_ID_INVALID,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    return positionTagHtmlID;
  };

  const getAllWalletLogPosition = async () => {
    const positionTagHtmlID = getPositionTagHtmlID();
    if (!positionTagHtmlID) {
      return;
    }

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let allWalletLogPosition = await sendRequestGetAllWalletLogPosition(
      positionTagHtmlID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allWalletLogPosition) {
      setPositionTagHtmlID();
      setAllWalletLogPosition([]);
      return;
    }
    setPositionTagHtmlID(positionTagHtmlID);
    setAllWalletLogPosition(allWalletLogPosition.position_log);
    setCountPage(allWalletLogPosition.count_page);
  };

  const sendRequestGetAllWalletLogPosition = async (positionTagHtmlID) => {
    const headersRequest = getHeaderRequest();
    let allWalletLogPosition;
    try {
      allWalletLogPosition = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/publisher/position-wallet-log/position/${positionTagHtmlID}?page=${currentPage}&number=${countItemPerPage}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allWalletLogPosition.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const generateAllWalletLogPosition = () => {
    return (
      <div className="pb-4 px-2">
        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره گزارش مالی جایگاه</td>
                <td>قیمت (تومان)</td>
                <td>تخفیف</td>
                <td>تاربخ درج</td>
              </tr>
            </thead>
            <tbody>
              {allWalletLogPosition.map((item, index) => {
                return (
                  <tr>
                    <td>{helperNumbers.toPersianNum(index + 1)}</td>
                    <td>{helperNumbers.toPersianNum(item.id)}</td>
                    <td className="letter-spacing-finance-number">
                      {helperNumbers.toPersianNum(
                        helperNumbers.toFormatFinanceNumber(item.price)
                      )}
                    </td>
                    <td>
                      {item.discountID ? (
                        item.discountID
                      ) : (
                        <span className="badge badge-danger">بدون تخفیف</span>
                      )}
                    </td>
                    <td>
                      {helperNumbers.toPersianNum(
                        item.created_at.split(" ")[1] +
                          " " +
                          helperTime.convertGregorianToJalali(
                            item.created_at.split(" ")[0]
                          )
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {countPage > 1 ? generatePagination() : <></>}
        </div>
      </div>
    );
  };

  const generatePositionDoseNotHaveWalletLog = () => {
    return (
      <div className="d-flex flex-column flex-md-row">
        <div className="text-center text-md-right">
          <img src="/assets/img/do-not-have-position.svg" />
        </div>
        <div className="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
          <p> این جایگاه در حال حاضر هیچ گزارشی ندارد </p>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar openItem="finance" activeItem="all-wallet-log-position" />

      <div className="content-wrapper">
        <TitleBar title="گزارش مالی جایگاه" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {messageTag}
              <div className="w-50">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    getAllWalletLogPosition();
                  }}
                >
                  <div class="input-group ">
                    <input
                      type="text"
                      id="position-tag-html-id"
                      class="form-control"
                      placeholder="تگ html جایگاه را وارد کنید"
                      required
                    />
                    <div class="input-group-append">
                      <button class="btn btn-primary" type="submit">
                        نمایش
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            {positionTagHtmlID &&
              (allWalletLogPosition.length > 0
                ? generateAllWalletLogPosition()
                : generatePositionDoseNotHaveWalletLog())}
          </div>
        </section>
      </div>
    </>
  );
}
